<!-- Carousel wrapper -->
<div class="slider-wrapper">
    <!-- Header -->
    <div class="carousel-header">
        <p class="content-color">
            Último contenido 
            <b [style.color]="companyColor()">{{ companyName() }}</b>
        </p>
        
        @if (isLoading()) {
            <span class="loading-badge">Cargando...</span>
        }
    </div>

    <!-- Error notification -->
    @if (error()) {
        <div class="error-notification">
            <p class="error-message">{{ error() }}</p>
            <button (click)="clearError()" class="btn-dismiss" aria-label="Cerrar notificación">×</button>
        </div>
    }

    <!-- Carousel slider -->
    @if (hasPosts()) {
        <div 
            class="slider" 
            (scroll)="onSlideChange($event)"
            role="region"
            aria-label="Carrusel de contenido destacado">
            
            @for (post of displayPosts(); track trackByPostId($index, post); let i = $index) {
                <article 
                    class="slide" 
                    [id]="'slide-' + i"
                    [class.active]="currentSlideIndex() === i"
                    [attr.aria-label]="'Post ' + (i + 1) + ' de ' + displayPosts().length">
                    
                    <!-- Media content -->
                    <div class="img-wrapper">
                        @if (post.post_info.post_type === 'IMAGE' || post.post_info.post_type === 'GIF') {
                            <img 
                                [src]="post.post_info.url" 
                                [alt]="post.post_info.text || 'Imagen del post'"
                                loading="lazy"
                                class="post-image"
                                (error)="$any($event.target).src = 'assets/images/placeholder.png'" />
                        }
                        @else if (post.post_info.post_type === 'VIDEO') {
                            <video 
                                [src]="post.post_info.url" 
                                controls
                                preload="metadata"
                                class="post-video"
                                [attr.aria-label]="'Video: ' + (post.post_info.text || 'Sin descripción')">
                                Tu navegador no soporta el elemento de video.
                            </video>
                        }
                        @else if (post.post_info.post_type === 'SURVEY') {
                            <div class="placeholder-content survey-placeholder">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path d="M9 11l3 3L22 4"></path>
                                    <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"></path>
                                </svg>
                                <p>Encuesta</p>
                            </div>
                        }
                        @else {
                            <div class="placeholder-content text-placeholder">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"></path>
                                    <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"></path>
                                </svg>
                                <p>Contenido de texto</p>
                            </div>
                        }
                    </div>

                    <!-- Post text -->
                    @if (post.post_info.text) {
                        <p class="post-text" [title]="post.post_info.text">
                            {{ post.post_info.text }}
                        </p>
                    }

                    <!-- Read more link -->
                    <div class="post-actions">
                        <a 
                            [routerLink]="['/posts', post.id]" 
                            class="btn-read-more"
                            [attr.aria-label]="'Ver más sobre: ' + (post.post_info.text || 'este post')">
                            Ver más
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                <path d="M5 12h14M12 5l7 7-7 7"></path>
                            </svg>
                        </a>
                    </div>
                </article>
            }
        </div>

        <!-- Carousel indicators -->
        @if (displayPosts().length > 1) {
            <div class="carousel-indicators" role="tablist" aria-label="Indicadores del carrusel">
                @for (post of displayPosts(); track post.id; let i = $index) {
                    <button
                        type="button"
                        class="indicator"
                        [class.active]="currentSlideIndex() === i"
                        (click)="navigateToSlide(i)"
                        [attr.aria-label]="'Ir a slide ' + (i + 1)"
                        [attr.aria-selected]="currentSlideIndex() === i"
                        role="tab">
                    </button>
                }
            </div>
        }
    }

    <!-- Empty state -->
    @if (isEmpty()) {
        <div class="empty-state">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <circle cx="8.5" cy="8.5" r="1.5"></circle>
                <path d="M21 15l-5-5L5 21"></path>
            </svg>
            <p>No hay contenido destacado disponible</p>
            <button (click)="retryLoadPosts()" class="btn-retry">
                Reintentar
            </button>
        </div>
    }

    <!-- Loading state -->
    @if (isLoading()) {
        <div class="loading-state">
            <div class="loading-spinner"></div>
            <p>Cargando contenido...</p>
        </div>
    }
</div>

<!-- Divider -->
<hr class="carousel-divider" />
